import { Component } from 'vue-property-decorator'
import Checkup from '@src/data/checkup'
import { WizardHealthLimitations } from '@src/routes/members/components/wizard/health-limitations'
import { MemberProfile } from '@src/data/member-profile'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    member () {
      return this.$store.state.memberProfile
    }
  }
})
export class MemberWizardHealthLimitations extends WizardHealthLimitations {

  protected member: MemberProfile
  protected checkup: Checkup

  constructor () {
    super()
  }

  protected loadLatestHealthLimitations (): any {
    this.healthLimitationsSet = this.member.healthLimitationsSet
    this.assignHealthLimResponseToData()
  }
}
